import React, { useContext } from "react";
import { Modal } from "../../Smart/Modal/Modal";
import { I18nReactContext } from "../../../contexts/I18nContext";
import { buttonColors } from "../../Pickers/InputTheme";
import { Button } from "../../Form/Button/Button";
import "./FirstLoginModal.scss";  // Add custom styles here
import firstLoginImage from "../../../assets/images/first-login-character.png"
import {Confetti} from "../../Smart/Confetti/Confetti";

export const FirstLoginModal = ({ openFirstLoginModal, closeFirstLoginModal }) => {
    const { i18n } = useContext(I18nReactContext);
    return (
        <Modal open={openFirstLoginModal} onClose={closeFirstLoginModal}>
            <div className="FirstLoginModal modalWrapper">
                <div className="modalContent">
                    <div className="imageSection">
                        <img
                            src={firstLoginImage}
                            alt=""
                            className="modalImage"
                        />
                    </div>
                    <div className="leftSection">
                        <div className="modalTitle">
                            {i18n.translate('FirstLoginModal.title')}
                        </div>
                        <div className="modalText">
                            {i18n.translate('FirstLoginModal.content')}
                        </div>
                        <div className="buttonContainer">
                            <Button
                                color={buttonColors.YELLOW}
                                onClick={closeFirstLoginModal}
                                text={i18n.translate('FirstLoginModal.takeMeHome')}
                                className="actionButton"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Confetti showConfetti={true}/>
        </Modal>
    );
}

